<template>
    <el-button type="primary" size="small" v-bind="$attrs" v-on="$listeners" style="min-width: 80px">
        <jj-icons type="new" />
        <slot>
            {{ $t('buttons.newEdit') }}
        </slot>
    </el-button>
</template>
<script>
export default {
    name: 'ButtonNew'
}
</script>
